import {
  AppstoreOutlined,
  BookOutlined,
  CarOutlined,
  DatabaseOutlined,
  EuroOutlined,
  FileTextOutlined,
  GiftOutlined,
  LineChartOutlined,
  RocketOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import i18n from "translations/i18n";
import urls from "urls";

const shopNavTree = [
  {
    key: "shop",
    title: "Fulfilment",
    breadcrumb: false,
    submenu: [
      {
        key: "shop-orders",
        path: urls.ordersList,
        title: i18n.t("order.orders"),
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-supplement-invoices",
        path: urls.supplementInvoices,
        title: "Nafacturaties",
        icon: EuroOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-pick-route",
        path: urls.pickRoute,
        title: i18n.t("pick_route.nav"),
        icon: AppstoreOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-product-data",
        path: urls.productData,
        title: i18n.t("product_data.nav"),
        icon: DatabaseOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-soocool",
        path: urls.soocool,
        title: i18n.t("soocool.search.nav"),
        icon: CarOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "shop-reports",
    title: i18n.t("reports"),
    icon: LineChartOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "shop-reports-dashboard",
        path: urls.reports,
        title: i18n.t("sales_dashboard"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-reports-customer-segments",
        path: urls.reportsCustomerSegments,
        title: i18n.t("customer_segments"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-reports-rfm",
        path: urls.rfmDashboard,
        title: i18n.t("rfm_analysis"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-reports-marketing-metrics",
        path: urls.reportsMarketingMetrics,
        title: i18n.t("marketing_metrics_nav"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-reports-campaign-reports",
        path: urls.reportsCampaignReports,
        title: i18n.t("campaign_reports_nav"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "marketing",
    title: i18n.t("marketing"),
    icon: RocketOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "marketing-campaigns",
        path: urls.campaigns,
        title: i18n.t("campaigns"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "marketing-utm-tool",
        path: urls.utmTool,
        title: i18n.t("utm_tool"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "loyalty",
    title: i18n.t("loyalty_program"),
    breadcrumb: false,
    submenu: [
      {
        key: "loyalty-users",
        path: urls.loyaltyUsers,
        title: i18n.t("loyalty_users"),
        icon: TeamOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "loyalty-rewards",
        path: urls.loyaltyRewards,
        title: i18n.t("loyalty_rewards"),
        icon: GiftOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "documentation",
    path: urls.documentation,
    title: i18n.t("documentation"),
    icon: BookOutlined,
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfig = [...shopNavTree];

export default navigationConfig;
